import { render } from "./SearchIcon.vue?vue&type=template&id=73ef8b7a&ts=true"
import script from "./SearchIcon.vue?vue&type=script&lang=ts"
export * from "./SearchIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__